import { createContext } from 'react';

export type ConfettiOptions = {
  onComplete: () => void;
};

type ConfettiContextType = {
  confetti: () => void;
};

export const ConfettiContext = createContext<ConfettiContextType>({
  confetti: () => {},
});
